import { render, staticRenderFns } from "./AccountAvatar.vue?vue&type=template&id=29597622&scoped=true"
import script from "./AccountAvatar.vue?vue&type=script&lang=js"
export * from "./AccountAvatar.vue?vue&type=script&lang=js"
import style0 from "./AccountAvatar.vue?vue&type=style&index=0&id=29597622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29597622",
  null
  
)

export default component.exports